export const APP = 'booksearch-app';
export const CRED = '00babf3de535:1793f112-bc25-40a7-8471-b59b9b11dbcd';
export const URL = 'https://appbase-demo-ansible-abxiydt-arc.searchbase.io';
export const TYPE = '_doc';
